var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merged-page" },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.bannedVisitors") }],
            select: true,
          },
        },
        [
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.startFilter") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            {
              staticClass: "side-menubar-wrapper",
              staticStyle: { width: "15%" },
            },
            [_c("UsersMenu")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "banned-visitors" } },
            [
              _c("b-container", { attrs: { fluid: "" } }, [
                _c("div", { staticClass: "audit-logs" }, [
                  _c("div", { staticClass: "page-header" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-wrapper" }, [
                    _c(
                      "section",
                      [
                        _c("ve-table", {
                          staticClass: "ban-list-table",
                          staticStyle: { width: "1130px" },
                          attrs: {
                            columns: _vm.getColumns(),
                            "table-data": _vm.getFilteredRows(),
                            "row-style-option": _vm.rowStyleOption,
                            "border-x": true,
                            "border-y": true,
                            "row-key-field-name": "_id",
                            "scroll-width": 1130,
                            virtualScrollOptions: { itemSize: 50, height: 500 },
                            "event-custom-option": _vm.eventCustomOption,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3 d-flex justify-content-end" },
                  [
                    _c("Pagination", {
                      attrs: {
                        "page-change": _vm.pageChange,
                        "page-sizes": _vm.pageSizes,
                        total: _vm.bannedVisitors.total,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fab d-flex justify-content-center align-items-center",
          on: {
            click: function ($event) {
              _vm.isBanModalShow = true
            },
          },
        },
        [_c("md-icon", {}, [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c("VisitorManuelBanModal", {
        attrs: { "ban-modal-visible": _vm.isBanModalShow },
        on: {
          close: function ($event) {
            _vm.isBanModalShow = false
          },
          update: _vm.refreshTable,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }